import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { classnames } from '@@client/lib/classes';
import FormOneliner from '@@client/components/FormOneliner';
export default function FormPrice(_ref) {
  var _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      className = _ref.className,
      formOnelinerAtts = _objectWithoutProperties(_ref, ["step", "className"]);

  return /*#__PURE__*/_jsx(FormOneliner, _objectSpread({
    type: "number",
    step: step,
    className: classnames(className, 'field--price')
  }, formOnelinerAtts));
}